var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGretaappBannerParamount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 830 95",
    style: {
      enableBackground: "new 0 0 830 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE500;}\n\t.st1{fill:none;}\n\t.st2{font-family:'PeakSans-Bold';}\n\t.st3{font-size:24px;}\n\t.st4{font-family:'PeakSans-Regular';}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M820,2c4.4,0,8,3.6,8,8v75c0,4.4-3.6,8-8,8H10c-4.4,0-8-3.6-8-8V10c0-4.4,3.6-8,8-8H820 M820,0H10 C4.5,0,0,4.5,0,10v75c0,5.5,4.5,10,10,10h810c5.5,0,10-4.5,10-10V10C830,4.5,825.5,0,820,0L820,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.6,50.7l4.8-13.4l4.7,13.4H271.6L271.6,50.7z M288,70.6h12.8L283.5,25h-14.4l-17.3,45.6h12.8l3-8.5H285 L288,70.6z M259.6,25h-39.2v11.3h13.5v34.3h12.2V36.3h13.5L259.6,25L259.6,25z M194.4,59.3v-6.1h21.8V41.9h-21.8v-5.5h22.9V25 h-35.1v45.6h35.6V59.3L194.4,59.3L194.4,59.3z M160.2,36.3c3,0,4.6,1.4,4.6,4.2s-1.6,4.1-4.6,4.1h-8.5v-8.3L160.2,36.3L160.2,36.3 z M164.9,70.6h14.3l-11-16c5.9-2.3,9.4-7.5,9.4-14.2c0-9.1-6.4-15.4-16.9-15.4h-21.2v45.6h12.2V55.9h4L164.9,70.6L164.9,70.6z  M136.9,48.3c0-1.7-0.1-3.2-0.2-3.8h-23v9.7h9.3c-1.5,3.3-4.4,5.4-9.1,5.4c-7.1,0-11.5-4.9-11.5-11.8S106.9,36,113.8,36 c3.8,0,6.6,1.4,8.9,4l9.8-7.8c-5.1-5.7-11.5-8.1-18.6-8.1c-14.1,0-24.2,9.7-24.2,23.6s10.3,23.7,24,23.7S137.2,61.6,136.9,48.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,17.8c-16.6,0-30,13.4-30,30c0,5.5,1.5,10.7,4.1,15.2l-5.9,9.5c0,0-0.5,0.7,0.3,0.5 c0.6-0.1,8.1-1.4,12.2-2.2c5.2,4.3,11.9,6.9,19.2,6.9c16.6,0,30-13.4,30-30S66.9,17.8,50.3,17.8z M47,28.9c0-0.5,0.3-0.7,0.8-0.4 l11.7,8.4c0.4,0.3,0.4,0.8,0,1.1l-11.7,8.4C47.3,46.7,47,46.5,47,46C47,46,47,28.9,47,28.9z M59.2,66H41.7c-1,0-1.9-0.8-1.9-1.9 c0-1,0.8-1.9,1.9-1.9h17.5c1,0,1.9,0.8,1.9,1.9S60.3,66,59.2,66z M66.1,57.1H34.6c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h31.4 c1,0,1.9,0.8,1.9,1.9C67.9,56.3,67.1,57.1,66.1,57.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 318.6,
    y: 24.2,
    className: "st1",
    width: 493,
    height: 46.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.5961 40.9621)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st2 st3"
  }, "Baixe o App "), /*#__PURE__*/React.createElement("tspan", {
    x: 137.1,
    y: 0,
    className: "st0 st4 st3"
  }, "e assista no cinema com"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28,
    className: "st0 st4 st3"
  }, "audiodescri\xE7\xE3o, legendas descritivas ou ")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGretaappBannerParamount);
export default __webpack_public_path__ + "static/media/gretaapp-banner-paramount.4c7cc425f5e55e96cdba32a237da309e.svg";
export { ForwardRef as ReactComponent };